import { defineMessages } from 'react-intl';

export const i18n: {
	searchClearFilterLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	searchClearFilterLabel: {
		id: 'dynamic-cards-search-page.filter.clear.filter.label',
		defaultMessage: 'Clear filter',
		description: 'Label for button to clear filter options',
	},
});
